import { useTranslation } from 'react-i18next'

import { Divider, Text } from '@reveni-io/reveni-ui'

import DeliveryMethods from './DeliveryMethods/DeliveryMethods'
import ShippingMethods from './ShippingMethods/ShippingMethods'

const LocationUsedInSection = ({
  locationId,
  shippingMethods,
  deliveryMethods,
  regions,
  onSelectShippingMethod,
  onSelectDeliveryMethod,
  allowsShipments,
}) => {
  const { t } = useTranslation()

  if (locationId === 'new' || locationId === 'duplicate') return null

  return (
    <>
      <Divider />
      <Text type="titleM">{t('Ubicación usada en')}:</Text>
      {allowsShipments && (
        <ShippingMethods
          shippingMethods={shippingMethods}
          regions={regions}
          onSelectShippingMethod={onSelectShippingMethod}
        />
      )}
      <DeliveryMethods
        deliveryMethods={deliveryMethods}
        regions={regions}
        onSelectDeliveryMethod={onSelectDeliveryMethod}
      />
    </>
  )
}

export default LocationUsedInSection
